// extracted by mini-css-extract-plugin
export default {"modalBody":"jobInfoModal_modalBody__bYOr7","modalBodyAttention":"jobInfoModal_modalBodyAttention__6BV5h","modalBodyInfo":"jobInfoModal_modalBodyInfo__Z7bvS"};